<!-- top5活跃学校 -->
<template>
    <div class="top-five-active-schools">
        <div class="top-five-active-schools-title">
            <div class="name">活跃学校top5</div>
        </div>
        <div class="top-five-active-schools-list">
            <div class="rank-list">
                <div class="top-five-active-schools-li" v-for="item, index in rankList" :key="item.id">
                    <div class="top-five-active-schools-no">No.{{ index + 1 }}</div>
                    <div class="school-name" :title="item.name">{{ item.name }}</div>
                    <div class="top-five-active-schools-progress">
                        <el-progress :percentage="item.progress" :stroke-width="14" :show-text="false"></el-progress>
                    </div>
                    <div class="top-five-active-schools-number">{{ item.number }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPlatformSchoolStatAPI } from "@/service/api.js"
export default {
    name: 'top-five-active-schools',
    components: {
    },
    props: {
        //区域id
        regionId: {
            type: String,
            default: ""
        },
        regionType: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            rankList: [],
        }
    },
    computed: {
        intervalTime() {
            return [this.startTime, this.endTime];
        }
    },
    watch: {
        intervalTime() {
            this.getPlatformSchoolStat();
        },
        address() {
            this.getPlatformSchoolStat();
        },
    },
    methods: {
        /**
         * @name 获取平台学校活跃度数据
         */
        getPlatformSchoolStat() {
            let params = {
                regionId: this.regionId,
                provinceId: this.provinceId,
                cityId: this.cityId,
                districtId: this.districtId,
                address: this.address,
                startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                keyWord: "",
                page: 1,
                limit: 5,
                sort: 'rsNum',
                regionType: this.regionType
            }
            getPlatformSchoolStatAPI(params).then((res) => {
                this.rankList = []
                let maxresourceNum = res.rows[0].rsNum
                this.rankList = res.rows.map((item) => {
                    return {
                        number: item.rsNum,
                        name: item.schoolName,
                        progress: (item.rsNum / maxresourceNum).toFixed(2) * 100||0,
                        id: item.schoolId
                    }
                })
            }).catch((err) => { })

        }
    },
    mounted() {
        //获取平台学校活跃度数据
        this.getPlatformSchoolStat()
    }
}
</script>
<style lang="scss" scoped>
.top-five-active-schools {
    width: 100%;
    height: 320px;
    background: rgba(9, 19, 66, 0.94);
    border-radius: 0px 0px 4px 4px;

    .top-five-active-schools-title {
        background: url("~@/assets/images/qingxudataboard/title-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    .top-five-active-schools-list {
        width: 100%;
        height: 280px;
        overflow-y: hidden;
        margin-top: 10px;
        padding-left: 10px;
        padding-right: 10px;

        .top-five-active-schools-li:nth-child(1) {
            .top-five-active-schools-no {
                color: #FFD321;
            }
        }
        .top-five-active-schools-li:nth-child(2) {
            .top-five-active-schools-no {
                color: #99FFF9;
            }
        }
        .top-five-active-schools-li:nth-child(3) {
            .top-five-active-schools-no {
                color: #FF723B;
            }
        }

        .top-five-active-schools-li {
            display: flex;
            align-items: center;
            padding: 14px 0;

            .top-five-active-schools-no {
                width: 35px;
                margin-right: 10px;
                text-align: left;
                font-size: 14px;
                font-family: DingTalkJinBuTi;
                font-weight: 400;
                color: #4CADC6;

                @font-face {
                    font-family: DingTalkJinBuTi;
                    src: url('../../../assets/fonts/DingTalkJinBuTi-Regular.ttf'); //字体路径
                }
            }
            .school-name {
                width: 130px;
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #5B90E6;
            }

            .top-five-active-schools-progress {
                width: 170px;
                text-align: left;
            }

            .top-five-active-schools-number {
                margin-left: 7px;
                // color: #fff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #5B90E6;
            }
        }
    }
}
</style>
<style lang="scss">
.top-five-active-schools-list {
    .top-five-active-schools-li {
        .top-five-active-schools-progress {
            .el-progress {
                .el-progress-bar {
                    .el-progress-bar__outer {
                        border-radius: 2px;

                        .el-progress-bar__inner {
                            border-radius: 2px;
                            background: linear-gradient(90deg, #36B381 0%, #5AD8A6 100%);
                        }
                    }
                }
            }
        }
    }
}
</style>